import React, { Component, useEffect, useState, useLayoutEffect } from 'react'
import Header from '../components/home/Header';
import NoticiasApi from '../services/robinhood/NoticiasApi';
import ListarNoticias from '../components/ListarNoticias';
import ListarNoticiasDestacadas from '../components/ListarNoticiasDestacadas';

export default function Noticias() {

  const [publicacoes, setPublicacoes] = useState([{ 'id': null, 'titulo': null, 'resumo': null, 'noticia': null, 'created_at': null }]);
  const [publicacao, setPublicacao] = useState({ 'id': null, 'titulo': null, 'resumo': null, 'noticia': null, 'created_at': null });
  const [publicacoesDestacadas, setPublicacoesDestacadas] = useState([]);

  useEffect(() => {
    document.getElementById('toggle-menu').className = 'theme-blush';
    getUtimas(4);
    getDestacadas();
  }, []);

  const getUtimas = async (_numeroPublicacoes) => {
    await new NoticiasApi().ultimas(_numeroPublicacoes).then(response => {
      if (response.length > 0) {
        setPublicacoes(response);
        localStorage.setItem('noticia', JSON.stringify(response[0]));
      }
    });
  }

  const getDestacadas = async () => {
    await new NoticiasApi().destacadas().then(response => {
      setPublicacoesDestacadas(response);
    });
  }

  const handlePublicacao = (_publicacao) => {
    setPublicacao(_publicacao);
  }

  return (
    <>
      <Header>
        <h5 style={{ marginLeft: '20px', marginBottom: '20px' }}> <i className='zmdi zmdi-reader'></i> PUBLICAÇÕES  </h5>
      </Header>

      {publicacoesDestacadas.length > 0 && <ListarNoticiasDestacadas publicacoes={publicacoesDestacadas} handlePublicacao={handlePublicacao}>
        <h6> <i className='zmdi zmdi-star text-warning' style={{ color: '' }}></i> DESTAQUES</h6>
      </ListarNoticiasDestacadas>}

      {(publicacoes.length > 0 && publicacoes[0].id != null) && <ListarNoticias publicacoes={publicacoes} handlePublicacao={handlePublicacao}>
        <h6>ÚLTIMAS PUBLICAÇÕES</h6>
      </ListarNoticias>}

      <div class="modal fade" id="largeModalPublicacao" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title" style={{ textTransform: 'uppercase' }} id="largeModalLabel">{publicacao.titulo}</h6>
            </div>

            <div class="modal-body">
              <p className='bold'><i className='zmdi zmdi-calendar'></i> {publicacao.data_publicacao && publicacao.data_publicacao.split('-').reverse().join('/')} </p>
              <div className="content" dangerouslySetInnerHTML={{ __html: publicacao.noticia }}></div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-link waves-effect btn-light" data-dismiss="modal"> FECHAR</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

